<template>
  <div class="job">
    <div class="jobContainer">
      <div class="job-detail">
        <div class="job-top">
          <h1 class="job-name">{{ jobDetail.job }}</h1>
          <h1 class="wage substring">{{ jobDetail.startSalary }}</h1>
        </div>
        <div class="job-detail-subTitle">
          <span class="tag" v-if="jobDetail.workingPlace">{{
            jobDetail.workingPlace
          }}</span>
          <span class="tag" v-if="jobDetail.educationName">{{
            jobDetail.educationName
          }}</span>
          <span class="tag" v-if="jobDetail.serviceName">{{
            jobDetail.serviceName
          }}</span>
        </div>
        <div class="job-detail-description job-detail-block">
          <h2>职位描述</h2>
          <pre class="textContent" v-html="jobDetail.jobInfo"></pre>
        </div>
        <div
          class="job-detail-requirement job-detail-block"
          v-if="reJobAttachmentTemplateList.length > 0"
        >
          <h2>附件</h2>
          <div
            class="textContent"
            v-for="(item, index) in reJobAttachmentTemplateList"
            :key="index"
          >
            <div v-if="item.existTemplate == '1'" class="template">
              <div class="template_name">
                <span class="template_name_title"
                  >名称:{{ item.templateName }} </span
                ><span style="margin-left: 20px">模版下载:</span>
                <el-button
                  type="text"
                  @click="
                    getUpload(item.objectKey, item.templateName, item.fileType)
                  "
                  >{{ item.templateName }} 点击下载</el-button
                >
              </div>
              <div class="fileInput" v-if="open && !flag">
                <el-button type="text"> 附件上传</el-button>
                <input
                  type="file"
                  class="file"
                  @change="
                    handleFileChange(
                      $event,
                      item.templateName,
                      item.fileType,
                      item.jobAttachmentTemplateId
                    )
                  "
                  accept=".jpg,.jpeg,.png,.pdf,.word"
                />
                <span
                  style="margin-left: 50px"
                  v-for="(ite, index) in reMiniProgramAttachmentList"
                  :key="index"
                  v-if="ite.attachmentName == item.templateName"
                >
                  {{ item.templateName }}.{{ item.fileType }}
                </span>
              </div>
            </div>
            <div class="template" v-else>
              <div class="template_name">
                <span class="template_name_title"
                  >名称:{{ item.templateName }} </span
                ><span style="margin-left: 20px">无模版下载</span>
              </div>
              <div class="fileInput" v-if="open && !flag">
                <el-button type="text"> 附件上传</el-button>
                <input
                  type="file"
                  class="file"
                  @change="
                    handleFileChange(
                      $event,
                      item.templateName,
                      item.fileType,
                      item.jobAttachmentTemplateId
                    )
                  "
                />
                <span
                  style="margin-left: 50px"
                  v-for="(ite, index) in reMiniProgramAttachmentList"
                  :key="index"
                  v-if="ite.attachmentName == item.templateName"
                >
                  {{ item.templateName }}.{{ item.fileType }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="job-detail-button job-detail-block">
          <bytedance-button @click="" size="large">投递</bytedance-button>
        </div> -->
      </div>
      <div class="job-company">
        <!-- <div class="job-button"> -->
        <!-- <div class="job-detail-button job-detail-block">
            <bytedance-button @click="" size="large">收藏</bytedance-button>
          </div> -->
        <div class="job-detail-button job-detail-block">
          <bytedance-button
            @click="saveResume"
            size="large"
            :class="[flag ? 'actvCss' : '']"
            >{{ flag ? "已投递" : "投递" }}</bytedance-button
          >
        </div>
        <!-- </div> -->
        <div class="relatedJobs-header">
          <div class="relatedJobs-header-pre"></div>
          <h3>公司</h3>
        </div>
        <div class="job-company-detail">
          <router-link :to="'/companyDetail/' + companyDetail.reCompanyId">
            <div class="companyName">{{ companyDetail.reCompanyName }}</div>
            <div class="company-detail-subTitle">
              <span class="tag" v-if="companyDetail.industry"
                >行业 : {{ companyDetail.industry }}</span
              >
              <span class="tag" v-if="companyDetail.enterpriseNature"
                >企业性质 :{{ companyDetail.enterpriseNature }}</span
              >
              <span class="tag" v-if="companyDetail.enterpriseScale"
                >规模 :{{ companyDetail.enterpriseScale }}</span
              >
            </div>
          </router-link>
        </div>
        <div class="relatedJobs-header">
          <div class="relatedJobs-header-pre"></div>
          <h3>推荐职位</h3>
        </div>
        <ul class="content-list">
          <li
            class="recommend-job-item"
            v-for="(item, index) in dataList"
            :key="index"
          >
            <router-link :to="'/jobDetail/' + item.jobId">
              <div class="job-top-container">
                <div class="job-top">
                  <div class="job-name substring">{{ item.job }}</div>
                  <div class="wage substring">{{ item.startSalary }}</div>
                </div>
                <div class="job-bottom substring">
                  <span class="tag" v-if="item.workingPlace">{{
                    item.workingPlace
                  }}</span
                  ><span class="tag" v-if="item.educationName">{{
                    item.educationName
                  }}</span
                  ><span class="tag" v-if="item.serviceName">{{
                    item.serviceName
                  }}</span>
                </div>
              </div>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getJobs,
  getCompany,
  getJobsList,
  getJobApplyStatus,
  applyForJob,
  personalInfo,
  download,
} from "@/api/index.js";
import store from "@/store";
import COS from "cos-js-sdk-v5";
import { getToken } from "@/helper/auth";
import { Debounce } from "@/helper/utilities.js";
export default {
  name: "jobDetail",
  data() {
    return {
      URL: "/prod-api",
      state: store.state,
      jobId: "",
      userInfo: {},
      jobDetail: {},
      companyDetail: {},
      dataList: [],
      reMiniProgramAttachmentList: [],
      reJobAttachmentTemplateList: [],
      attachmentUploadVisible: false,
      flag: false,
      open: false,
    };
  },
  created() {
    this.jobId = this.$route.params.id;
    this.getJobsDetail();
    this.getlist();
  },
  methods: {
    //职位详情
    getJobsDetail() {
      getJobs(this.jobId)
        .then((res) => {
          this.jobDetail = res.data;
          this.reJobAttachmentTemplateList =
            res.data.reJobAttachmentTemplateList;
          this.getCompanyDetail(res.data.companyId);
          if (getToken()) {
            this.getJobApply(res.data.jobId);
            this.getPersonalInfo();
          }
        })
        .catch(() => {});
    },

    //公司详情
    getCompanyDetail(companyId) {
      getCompany(companyId)
        .then((res) => {
          this.companyDetail = res.data;
        })
        .catch(() => {});
    },

    //推荐岗位
    getlist() {
      let data = {
        pageNum: 1,
        pageSize: 5,
      };
      const loading = this.$loading();
      getJobsList(data)
        .then((res) => {
          loading.close();
          this.dataList = res.data;
        })
        .catch(() => {
          loading.close();
        });
    },

    //获取岗位投递状态
    getJobApply(jobId) {
      getJobApplyStatus(jobId)
        .then((res) => {
          if (res.code == 200) {
            this.flag = res.data;
          }
        })
        .catch(() => {});
    },

    //获取个人信息
    getPersonalInfo() {
      personalInfo().then((res) => {
        if (res.code == 200) {
          if (res.data.reMiniProgramPerson !== null) {
            this.open = true;
            this.userInfo = res.data.reMiniProgramPerson;
          }
        }
      });
    },

    //文件下载
    getUpload(resume, templateName, fileType) {
      download(resume).then((response) => {
        let contractFileName = templateName + "." + fileType;
        this.getObjectURL(response, contractFileName);
      });
    },
    // 将返回的文件流数据转换为url（data: 文件流数据）
    getObjectURL(data, contractFileName) {
      let blob = new Blob([data]);
      let fileName = contractFileName;
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, fileName);
      } else {
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        //释放内存
        window.URL.revokeObjectURL(link.href);
      }
    },

    //上传附件
    handleFileChange(event, templateName, fileType, jobAttachmentTemplateId) {
      const input = event.target;
      let types = input.files[0].name.split(".")[1];
      let objectKey =
        "微信招聘小程序/" +
        this.companyDetail.reCompanyName +
        "/" +
        this.jobDetail.job +
        "/" +
        this.userInfo.realName +
        "-" +
        this.state.phoneNumber +
        "." +
        types;
      if (types == fileType) {
        const files = input.files[0];
        let filesSize = files.size;
        if (filesSize / (1024 * 1024) < 10) {
          this.uploads(files, objectKey, templateName, jobAttachmentTemplateId);
        } else {
          this.$message({
            type: "warning",
            message: "文件过大，建议不要超过10M！",
          });
        }
      } else {
        this.$message({
          type: "warning",
          message: "请选择" + fileType + "格式的文件",
        });
      }
    },

    //loading
    showLoading() {
      this.load = this.$loading({
        lock: true,
        text: "上传中",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },

    //上传
    uploads(files, objectKey, templateName, jobAttachmentTemplateId) {
      let _this = this;
      _this.showLoading();
      // 初始化实例
      const cos = new COS({
        // getAuthorization 必选参数
        getAuthorization: function (options, callback) {
          const url = _this.URL + "/api/miniProgram/getCosAuth";
          const xhr = new XMLHttpRequest();
          xhr.open("get", url, true);
          xhr.onload = function (e) {
            let data = JSON.parse(xhr.response).data;
            let timestamp = Math.floor(data.startTime / 1000);
            callback({
              TmpSecretId: data.tmpSecretId,
              TmpSecretKey: data.tmpSecretKey,
              SecurityToken: data.sessionToken,
              StartTime: timestamp, // 时间戳，单位秒，如：1580000000
              ExpiredTime: timestamp + 60, // 时间戳，单位秒，如：1580000000
            });
          };
          xhr.send();
        },
      });

      cos.uploadFile(
        {
          Bucket: "zhaopin-1322091753" /* 填写自己的 bucket，必须字段 */,
          Region: "ap-nanjing" /* 存储桶所在地域，必须字段 */,
          Key: objectKey /* 存储在桶里的对象键（例如:1.jpg，a/b/test.txt，图片.jpg）支持中文，必须字段 */,
          Body: files, // 上传文件对象
          SliceSize:
            1024 *
            1024 *
            10 /* 触发分块上传的阈值，超过5MB使用分块上传，小于5MB使用简单上传。可自行设置，非必须 */,
          onProgress: function (progressData) {
            console.log(JSON.stringify(progressData));
          },
        },
        function (err, data) {
          if (err) {
            _this.load.close();
            _this.$message.error("上传失败");
          } else {
            _this.load.close();
            _this.$message({
              type: "success",
              message: "上传成功!",
            });
            _this.reMiniProgramAttachmentList.push({
              jobAttachmentTemplateId: jobAttachmentTemplateId,
              attachmentName: templateName,
              attachmentObjectKey: objectKey,
              hide: true,
            });
          }
        }
      );
    },

    //投递
    saveResume: Debounce(function () {
      if (getToken()) {
        if (
          this.userInfo &&
          this.userInfo.realName &&
          this.userInfo.workingPlace
        ) {
          if (
            this.reJobAttachmentTemplateList.length ==
            this.reMiniProgramAttachmentList.length
          ) {
            applyForJob(this.jobId, this.reMiniProgramAttachmentList).then(
              (res) => {
                if (res.code == 200) {
                  this.$message({
                    showClose: true,
                    message: res.msg,
                    type: "success",
                  });
                  this.getJobApply(this.jobId);
                }
              }
            );
          } else {
            this.$message({
              type: "warning",
              message: "请上传全部的文件",
            });
          }
        } else {
          this.$message({
            type: "warning",
            message: "请前往我的简历去填写个人信息",
          });
        }
      } else {
        this.$router.push({ path: "/user" });
      }
    }, 1000),
  },
};
</script>
<style lang="less" scoped>
.job {
  background-color: #f3f3f3;
  padding-bottom: 30px;
  .jobContainer {
    width: @main-width;
    margin: auto;
    padding-top: 50px;
    line-height: 2em;
    display: flex;
    justify-content: center;
    .job-detail {
      width: 900px;
      padding: 40px;
      background: #fff;
      box-shadow: 0 2px 10px rgba(54, 97, 174, 0.1);
      border-radius: 8px;
      .job-top {
        -ms-flex-align: center;
        -ms-flex-pack: justify;
        align-items: center;
        display: -ms-flexbox;
        display: flex;
        justify-content: space-between;
        box-sizing: border-box;
        .job-name {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .wage {
          flex: 1;
          justify-content: flex-end;
          display: flex;
          color: #d9011e;
          align-items: center;
          white-space: nowrap;
        }
      }
      &-subTitle {
        font-size: @font-size-base;
        color: @primary-text-color;
        margin: 20px 0;
        .tag:not(:first-child):before {
          content: "|";
          margin: 0 4px;
        }
      }
      &-description {
        .textContent {
          white-space: pre-line;
        }
      }
      &-block {
        h2 {
          margin-bottom: 20px;
        }
        margin: 40px 0;
        .textContent {
          font-size: @font-size-base;
          color: @primary-text-color;
          .template {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            .template_name {
              width: 100%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              word-break: break-all;
              margin-right: 50px;
              .template_name_title {
                width: 200px;
                display: inline-flex;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                word-break: break-all;
              }
            }
            .fileInput {
              position: relative;
              .file {
                position: absolute;
                cursor: pointer;
                opacity: 0;
                z-index: 15;
                left: 0;
                width: 58px;
                height: 40px;
              }
            }
          }
        }
      }
    }
    .job-company {
      margin-left: 20px;
      padding: 40px;
      width: 380px;
      background: #fff;
      box-shadow: 0 2px 10px rgba(54, 97, 174, 0.1);
      border-radius: 8px;
      .job-button {
        display: flex;
        .job-detail-button {
          width: 140px;
          margin-right: 20px;
        }
        .job-detail-button:nth-last-child(1) {
          margin-right: 0;
        }
      }
      .actvCss {
        background-color: #585857;
      }
      .relatedJobs-header {
        display: -ms-flexbox;
        display: flex;
        -ms-flex-align: center;
        align-items: center;
        font-size: 20px;
        line-height: 28px;
        font-weight: 500;
      }
      .relatedJobs-header-pre {
        width: 4px;
        height: 19px;
        margin-right: 8px;
        background-color: #00a0e9;
      }

      .job-company-detail {
        padding: 20px 0;
        .companyName {
          font-weight: 600;
        }
        .company-detail-subTitle {
          font-size: 14px;
          .tag:not(:first-child):before {
            content: "|";
            margin: 0 4px;
          }
        }
      }

      .content-list {
        margin-top: 20px;
        display: flex;
        flex-wrap: wrap;
        .recommend-job-item {
          background-color: #fff;
          -webkit-box-sizing: content-box;
          box-sizing: content-box;
          margin-bottom: 21px;
        }

        .job-top-container {
          border-bottom: 1px dotted #666;
          line-height: 30px;
          padding-bottom: 10px;
          .job-top {
            -ms-flex-align: center;
            -ms-flex-pack: justify;
            align-items: center;
            display: -ms-flexbox;
            display: flex;
            justify-content: space-between;
            .job-name {
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              word-break: break-all;
              text-align: left;
              width: 150px;
            }
            .wage {
              color: #d9011e;
              font-size: 16px;
              text-align: right;
              width: 150px;
            }
          }
        }

        .substring {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          word-break: break-all;
          text-align: left;
        }
        .tag {
          font-size: 14px;
          overflow: hidden;
          max-width: 150px;
          text-overflow: ellipsis;
          white-space: nowrap;
          word-break: break-all;
          display: inline-block;
        }
        .tag:not(:first-child):before {
          content: "|";
          margin: 0 4px;
          max-width: 100px;
        }
      }
    }
  }
}
</style>
